(() => {
  const ROOT_SELECTOR = ".promo-popup";
  const CLOSE_SELECTOR = ".promo-popup__close";
  const CLOSING_CLASS = "is-closing";
  const FALLBACK_MS = 350;

  const onClick = (e) => {
    const closeBtn = e.target.closest(CLOSE_SELECTOR);
    if (!closeBtn) return;

    const popup = closeBtn.closest(ROOT_SELECTOR);
    if (!popup) return;

    if (popup.classList.contains(CLOSING_CLASS)) return;
    popup.classList.add(CLOSING_CLASS);

    const finish = () => {
      popup.style.display = "none";
    };

    const onEnd = (evt) => {
      if (evt.target !== popup) return;
      popup.removeEventListener("transitionend", onEnd);
      finish();
    };

    popup.addEventListener("transitionend", onEnd);
    window.setTimeout(() => {
      popup.removeEventListener("transitionend", onEnd);
      finish();
    }, FALLBACK_MS);
  };

  window.addEventListener("click", onClick, { passive: true });
})();
